import * as _ from 'lodash'
import React, { useEffect } from 'react';
import componentServices from '../componentServices';
import * as actions from '../actions';
import * as contractorActions from '../contractorActions';
import contractorFactory, { IContractor } from '../models/contractorModel';
import enums from '../enum';
import { useSaveRoot } from '../saveRoot';
import { IPatchOperation } from 'Scripts/modelFactory';
import { getModel, ModelCollection } from 'Scripts/store';

class ContractorEditHeader extends React.Component<any,any> {
	handleRouteClick (key, e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.replacePathSegmentAt(3, key, true));
	}

	render () {
		const contractor = this.props.contractor;
		const items:JSX.Element[] = [];
		const currentModule = componentServices.routeParams.modulekey;
		const isNewContractor = !contractor.relayId

		if(!contractor) {
			return null;
		}

		const buttons = [{
			path: 'overview',
			name: 'Contractor Overview',
			featureSuffix: 'basic',
			includeType: enums.contractorTypes.Retail_Builder | enums.contractorTypes.Renovation_Contractor | enums.contractorTypes.Subtrade_Contractor | enums.contractorTypes.Delivery_Company,
			includeModules: ['retail-sales']
		}, {
			path: 'overview',
			name: 'Builder Overview',
			featureSuffix: 'basic',
			includeType: enums.contractorTypes.Developer | enums.contractorTypes.Multifamily_Developer,
			includeModules: ['builder-sales']
		}, {
			path: 'template',
			name: 'Models',
			featureSuffix: 'templates',
			hideForNew: true,
			includeType: enums.contractorTypes.Retail_Builder | enums.contractorTypes.Developer | enums.contractorTypes.Multifamily_Developer
		}, {
			path: 'client-upgrade',
			name: 'Client Upgrades',
			featureSuffix: 'templates',
			hideForNew: true,
			includeType: enums.contractorTypes.Retail_Builder | enums.contractorTypes.Developer | enums.contractorTypes.Multifamily_Developer
		}, {
			path: 'builder-upgrade',
			name: 'Builder Upgrades',
			featureSuffix: 'templates',
			hideForNew: true,
			includeType: enums.contractorTypes.Retail_Builder | enums.contractorTypes.Developer | enums.contractorTypes.Multifamily_Developer
		}, {
			path: 'contact',
			name: 'Contacts',
			featureSuffix: 'basic',
			hideForNew: true,
			includeType: enums.contractorTypes.Developer | enums.contractorTypes.Multifamily_Developer
		}, {
			path: 'files',
			name: 'Files',
			featureSuffix: 'basic',
			hideForNew: true
		}];

		_.forEach(buttons, x => {
			if ((isNewContractor && x.hideForNew) || (x.includeModules && x.includeModules.indexOf(currentModule) === -1) || !componentServices.securityContext.currentUserHasFeature(currentModule, `contractor-${x.featureSuffix}`) || (x.includeType && !(x.includeType & contractor.type))) {
				return;
			}

			let className = 'button';

			// TODO: deal with possible disabled status of header links
			className += (componentServices.router.getLastPathSegment() === x.path) ? ' on' : '';

			items.push(<li key={x.path}><a onClick={this.handleRouteClick.bind(this, x.path)} className={className}><span>{x.name}</span></a></li>);
		});

		//const className = 'jobStatus';
		const primaryContactName = (contractor && contractor.primaryContact) ? contractor.primaryContact.fullName : '';
		const primaryContactNumber = (contractor && contractor.primaryContact) ? contractor.primaryContact.mobilePhoneNumber || contractor.primaryContact.workPhoneNumber : '';

		return (
			<header key={ contractor.key }>
				<div className="builderStatus good">In Good Standing</div>
				<div className="clientInfo">{primaryContactName} <span>{primaryContactNumber}</span></div>
				<ul className="menu">
					{items}
				</ul>
			</header>
		);
	}
}

export default function ContractorEdit(props){
	const currentModule = componentServices.routeParams.modulekey;
	const contractorKey = componentServices.routeParams.contractorkey;
	const saveRootConfig = {
		autoSave:  true,
		globalSave: true,
		warnOnLeave: true,
		stateId: `ContractorEdit-${contractorKey}`,
		modelFactory: contractorFactory,
		resolveMutableModel (current:IContractor): [IContractor, boolean] {
			const storeContractor = getModel({ store: componentServices.store, collection: ModelCollection.contractors, key: contractorKey });
			let contractor = current;
			let rebase = false;

			if (storeContractor) {
				if (!current || storeContractor.key !== current.key) {
					contractor = contractorFactory(storeContractor.toDocument());
				}
				else if (storeContractor.key === current.key && storeContractor.itemVersion !== current.itemVersion) {
					contractor = contractorFactory(storeContractor.toDocument());
					rebase = true;
				}
			}
			else if (!current) { // if we've reached this point, this is a new contractor
				const type = currentModule === 'builder-sales' ? enums.contractorTypes.Developer : 0;
				contractor = contractorFactory({ key: contractorKey, type: type, status: 'active' });
			}

			return [contractor, rebase];
		},
		save: (doc, patch: IPatchOperation[]) => contractorActions.saveContractor({ contractor: doc, patch }),
		validate(model) {
			return model.test() || [];
		}
	};
	const [saveRoot] = useSaveRoot<IContractor>(saveRootConfig);
	const headerContractor = saveRoot.model??saveRootConfig.resolveMutableModel(null)[0];

	useEffect(() => {
		actions.setHeader({
			key: 'contractorEditHeader',
			element: (<ContractorEditHeader key={ headerContractor.key } contractor= { headerContractor } />)
		});

		return () => {
			actions.deleteHeader({ key: 'contractorEditHeader' });
		}
	}, [headerContractor]);

	function updateModel (updater, options) {
		saveRoot.update((contractor) => {
			updater(contractor);

			if (contractor.primaryContact && contractor.primaryContact.isEmpty()) {
				contractor.primaryContact = undefined;
			}

			if (contractor.officeAddress && contractor.officeAddress.isEmpty()) {
				contractor.officeAddress = undefined;
			}
		}, options);
	}

	const { children, ...childProps } = props;
	
	return (saveRoot.model) ? children && React.cloneElement(children, _.assign({ key: saveRoot.model.key, contractor: saveRoot.model, updateModel }, childProps)) : null;
}